import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ITab } from './interfaces/tab.interface';

@Component({
	selector: 'tabs-row',
	templateUrl: './tabs-row.component.html',
	styleUrls: ['./tabs-row.component.scss'],
})
export class TabsRow {
	@Input() tabList: ITab[];
	@Input() selectedTabIndex = 0;

	@Output('changeTab') changeTab = new EventEmitter<number>();

	clickTab(tabIndex): void {
		if (this.tabList[tabIndex].state === 'disabled') {
			return;
		}

		this.selectedTabIndex = tabIndex;
		this.changeTab.emit(tabIndex);
	}
}
